import { type Actions, ActionType } from './timeseries-tag.actions';
import { initialState, type State, timeseriesTagAdapter } from './timeseries-tag.state';

export function timeseriesTagReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET: {
            return initialState;
        }
        case ActionType.FETCH_TIMESERIES_TAG: {
            return { ...state, isPending: true };
        }
        case ActionType.FETCH_TIMESERIES_TAG_SUCCEEDED: {
            return timeseriesTagAdapter.setAll(action.payload.timeseriesTags, { ...state, isLoaded: true, isPending: false });
        }
        case ActionType.FETCH_TIMESERIES_TAG_FAILED: {
            return { ...state, isLoaded: false, isPending: false };
        }
        default:
            return state;
    }
}
